import {
  getStorage,
  connectStorageEmulator,
  uploadBytes,
  getDownloadURL,
  ref,
} from 'firebase/storage';

const STORAGE_FOLDER_ROOT = 'nyc-hoops';

const storage = getStorage();

if (process.env.NODE_ENV === 'development') {
  connectStorageEmulator(storage, 'localhost', 9199);
}

/**
 * Uploads a file to Cloud Storage.
 * @param {Object} options - The options object.
 * @param {string} options.hoopId - The ID of the hoop in Firebase.
 * @param {File} options.file - The `File` to upload.
 * @param {string} options.email - The email of the user.
 * @return {Object} - The upload result object along with the storage file URL.
 */
const uploadFileToStorage = async ({ hoopId, file, email }) => {
  const path = `${STORAGE_FOLDER_ROOT}/${hoopId}/${email}/${file.name}`;
  const storageRef = ref(storage, path);
  const metadata = { customMetadata: { hoopId } };

  const result = await uploadBytes(storageRef, file, metadata);
  const storageFileUrl = await getDownloadURL(result.ref);

  return { ...result, storageFileUrl };
};

export { storage, uploadFileToStorage };
